export const getQueryVariable = (queryString, variable) => {
  const query = queryString.substring(1);
  const vars = query.split('&');

  for (let i = 0; i < vars.length; i + 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
};

export const getParam = (location, name) => {
  const searchParams = new window.URLSearchParams(location.search);
  return searchParams.get(name);
};

export const filterByCourse = (items, pathName, subsitesArray) => {
  const pathArray = pathName.split('/').slice(1, -1);
  const pathCourseFolder = pathArray.filter(folderName => subsitesArray.indexOf(folderName) >= 0);

  return items.filter((item) => {
    const slugFolderArray = item.slug.split('/').slice(1, -1);
    const slugCourseFolder = slugFolderArray.filter(folderName => subsitesArray.indexOf(folderName) >= 0);

    if (pathCourseFolder[0] !== undefined && slugFolderArray.indexOf(pathCourseFolder[0]) !== -1) { return true; }
    if (pathCourseFolder[0] === undefined && slugCourseFolder[0] === undefined) { return true; }

    return false;
  });
};



// WEBPACK FOOTER //
// ./src/components/helpers/helpers.js